
//AUTH
export const REGISTER_REQUEST ="REGISTER_REQUEST";
export const REGISTER_SUCCESS ="REGISTER_SUCCESS";
export const REGISTER_FAILURE ="REGISTER_FAILURE";

export const LOGIN_REQUEST ="LOGIN_REQUEST";
export const LOGIN_SUCCESS ="LOGIN_SUCCESS";
export const LOGIN_FAILURE ="LOGIN_FAILURE";

export const VERIFY_OTP_REQUEST ="VERIFY_OTP_REQUEST";
export const VERIFY_OTP_SUCCESS ="VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_FAILURE ="VERIFY_OTP_FAILURE";

export const PASSWORD_RESET_REQUEST ="PASSWORD_RESET_REQUEST";
export const PASSWORD_RESET_SUCCESS ="PASSWORD_RESET_SUCCESS";
export const PASSWORD_RESET_FAILURE ="PASSWORD_RESET_FAILURE";

export const PASSWORD_RESET_CONFIRM_REQUEST ="PASSWORD_RESET_CONFIRM_REQUEST";
export const PASSWORD_RESET_CONFIRM_SUCCESS ="PASSWORD_RESET_CONFIRM_SUCCESS";
export const PASSWORD_RESET_CONFIRM_FAILURE ="PASSWORD_RESET_CONFIRM_FAILURE";

export const CHANGE_PASSWORD_REQUEST ="CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS ="CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE ="CHANGE_PASSWORD_FAILURE";

export const ACTIVATE_ACCOUNT_REQUEST ="ACTIVATE_ACCOUNT_REQUEST";
export const ACTIVATE_ACCOUNT_SUCCESS ="ACTIVATE_ACCOUNT_SUCCESS";
export const ACTIVATE_ACCOUNT_FAILURE ="ACTIVATE_ACCOUNT_FAILURE";

export const CHECK_EMAIL_REQUEST ="CHECK_EMAIL_REQUEST";
export const CHECK_EMAIL_SUCCESS ="CHECK_EMAIL_SUCCESS";
export const CHECK_EMAIL_FAILURE ="CHECK_EMAIL_FAILURE";

export const REQUEST_ACCOUNT_DELETION_REQUEST ="REQUEST_ACCOUNT_DELETION_REQUEST";
export const REQUEST_ACCOUNT_DELETION_SUCCESS ="REQUEST_ACCOUNT_DELETION_SUCCESS";
export const REQUEST_ACCOUNT_DELETION_FAILURE ="REQUEST_ACCOUNT_DELETION_FAILURE";

export const LOGOUT ="LOGOUT";

//UPDATE USER PROFILE
export const UPDATE_PROFILE_REQUEST ="UPDATE_PROFILE_REQUEST";
export const UPDATE_PROFILE_SUCCESS ="UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAILURE ="UPDATE_PROFILE_FAILURE";

//DRIVER PARTNER PROFILE
export const REGISTER_DRIVER_REQUEST ="REGISTER_DRIVER_REQUEST";
export const REGISTER_DRIVER_SUCCESS ="REGISTER_DRIVER_SUCCESS";
export const REGISTER_DRIVER_FAILURE ="REGISTER_DRIVER_FAILURE";

export const FETCH_MY_DRIVER_PARTNER_REQUEST ="FETCH_MY_DRIVER_PARTNER_REQUEST";
export const FETCH_MY_DRIVER_PARTNER_SUCCESS ="FETCH_MY_DRIVER_PARTNER_SUCCESS";
export const FETCH_MY_DRIVER_PARTNER_FAILURE ="FETCH_MY_DRIVER_PARTNER_FAILURE";

export const REGISTER_DRIVER_PARTNER_REQUEST ="REGISTER_DRIVER_PARTNER_REQUEST";
export const REGISTER_DRIVER_PARTNER_SUCCESS ="REGISTER_DRIVER_PARTNER_SUCCESS";
export const REGISTER_DRIVER_PARTNER_FAILURE ="REGISTER_DRIVER_PARTNER_FAILURE";

export const UPDATE_DRIVER_PARTNER_REQUEST ="UPDATE_DRIVER_PARTNER_REQUEST";
export const UPDATE_DRIVER_PARTNER_SUCCESS ="UPDATE_DRIVER_PARTNER_SUCCESS";
export const UPDATE_DRIVER_PARTNER_FAILURE ="UPDATE_DRIVER_PARTNER_FAILURE";

export const FETCH_REFERRED_DRIVERS_REQUEST ="FETCH_REFERRED_DRIVERS_REQUEST";
export const FETCH_REFERRED_DRIVERS_SUCCESS ="FETCH_REFERRED_DRIVERS_SUCCESS";
export const FETCH_REFERRED_DRIVERS_FAILURE ="FETCH_REFERRED_DRIVERS_FAILURE";

export const FETCH_REFERRAL_MILESTONES_REQUEST ="FETCH_REFERRAL_MILESTONES_REQUEST";
export const FETCH_REFERRAL_MILESTONES_SUCCESS ="FETCH_REFERRAL_MILESTONES_SUCCESS";
export const FETCH_REFERRAL_MILESTONES_FAILURE ="FETCH_REFERRAL_MILESTONES_FAILURE";

export const FETCH_PENDING_COMMISSIONS_REQUEST ="FETCH_PENDING_COMMISSIONS_REQUEST";
export const FETCH_PENDING_COMMISSIONS_SUCCESS ="FETCH_PENDING_COMMISSIONS_SUCCESS";
export const FETCH_PENDING_COMMISSIONS_FAILURE ="FETCH_PENDING_COMMISSIONS_FAILURE";

//DRIVER PARTNER PAYOUTS
export const FETCH_PARTNER_PAYOUTS_REQUEST ="FETCH_PARTNER_PAYOUTS_REQUEST";
export const FETCH_PARTNER_PAYOUTS_SUCCESS ="FETCH_PARTNER_PAYOUTS_SUCCESS";
export const FETCH_PARTNER_PAYOUTS_FAILURE ="FETCH_PARTNER_PAYOUTS_FAILURE";

//notifications
export const FETCH_NOTIFICATIONS_REQUEST = "FETCH_NOTIFICATIONS_REQUEST";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const FETCH_NOTIFICATIONS_FAILURE = "FETCH_NOTIFICATIONS_FAILURE";

export const MARK_NOTIFICATION_READ_REQUEST = "MARK_NOTIFICATION_READ_REQUEST";
export const MARK_NOTIFICATION_READ_SUCCESS = "MARK_NOTIFICATION_READ_SUCCESS";
export const MARK_NOTIFICATION_READ_FAILURE = "MARK_NOTIFICATION_READ_FAILURE";

//support ticket 
export const CREATE_SUPPORT_TICKET_REQUEST ="CREATE_SUPPORT_TICKET_REQUEST";
export const CREATE_SUPPORT_TICKET_SUCCESS ="CREATE_SUPPORT_TICKET_SUCCESS";
export const CREATE_SUPPORT_TICKET_FAILURE ="CREATE_SUPPORT_TICKET_FAILURE";

export const GET_SUPPORT_TICKETS_REQUEST ="GET_SUPPORT_TICKETS_REQUEST";
export const GET_SUPPORT_TICKETS_SUCCESS ="GET_SUPPORT_TICKETS_SUCCESS";
export const GET_SUPPORT_TICKETS_FAILURE ="GET_SUPPORT_TICKETS_FAILURE";

//driver
export const FETCH_DRIVER_BY_ID_REQUEST ="FETCH_DRIVER_BY_ID_REQUEST";
export const FETCH_DRIVER_BY_ID_SUCCESS ="FETCH_DRIVER_BY_ID_SUCCESS";
export const FETCH_DRIVER_BY_ID_FAILURE ="FETCH_DRIVER_BY_ID_FAILURE";

export const REGISTER_DRIVER_FOR_USER_REQUEST ="REGISTER_DRIVER_FOR_USER_REQUEST";
export const REGISTER_DRIVER_FOR_USER_SUCCESS ="REGISTER_DRIVER_FOR_USER_SUCCESS";
export const REGISTER_DRIVER_FOR_USER_FAILURE ="REGISTER_DRIVER_FOR_USER_FAILURE";

export const UPDATE_DRIVER_FOR_PARTNER_REQUEST ="UPDATE_DRIVER_FOR_PARTNER_REQUEST";
export const UPDATE_DRIVER_FOR_PARTNER_SUCCESS ="UPDATE_DRIVER_FOR_PARTNER_SUCCESS";
export const UPDATE_DRIVER_FOR_PARTNER_FAILURE ="UPDATE_DRIVER_FOR_PARTNER_FAILURE";

export const UPDATE_VEHICLE_FOR_PARTNER_REQUEST ="UPDATE_VEHICLE_FOR_PARTNER_REQUEST";
export const UPDATE_VEHICLE_FOR_PARTNER_SUCCESS ="UPDATE_VEHICLE_FOR_PARTNER_SUCCESS";
export const UPDATE_VEHICLE_FOR_PARTNER_FAILURE ="UPDATE_VEHICLE_FOR_PARTNER_FAILURE";

export const REGISTER_VEHICLE_FOR_USER_REQUEST ="REGISTER_VEHICLE_FOR_USER_REQUEST";
export const REGISTER_VEHICLE_FOR_USER_SUCCESS ="REGISTER_VEHICLE_FOR_USER_SUCCESS";
export const REGISTER_VEHICLE_FOR_USER_FAILURE ="REGISTER_VEHICLE_FOR_USER_FAILURE";

export const FETCH_RECRUITED_VEHICLES_REQUEST ="FETCH_RECRUITED_VEHICLES_REQUEST";
export const FETCH_RECRUITED_VEHICLES_SUCCESS ="FETCH_RECRUITED_VEHICLES_SUCCESS";
export const FETCH_RECRUITED_VEHICLES_FAILURE ="FETCH_RECRUITED_VEHICLES_FAILURE";

//faq
export const FETCH_FAQS_REQUEST ="FETCH_FAQS_REQUEST";
export const FETCH_FAQS_SUCCESS ="FETCH_FAQS_SUCCESS";
export const FETCH_FAQS_FAILURE ="FETCH_FAQS_FAILURE";

//help topic
export const FETCH_HELP_TOPICS_REQUEST ="FETCH_HELP_TOPICS_REQUEST";
export const FETCH_HELP_TOPICS_SUCCESS ="FETCH_HELP_TOPICS_SUCCESS";
export const FETCH_HELP_TOPICS_FAILURE ="FETCH_HELP_TOPICS_FAILURE";

//policy
export const FETCH_POLICIES_REQUEST ="FETCH_POLICIES_REQUEST";
export const FETCH_POLICIES_SUCCESS ="FETCH_POLICIES_SUCCESS";
export const FETCH_POLICIES_FAILURE ="FETCH_POLICIES_FAILURE";

//resources
export const FETCH_RESOURCES_REQUEST = "FETCH_RESOURCES_REQUEST";
export const FETCH_RESOURCES_SUCCESS = "FETCH_RESOURCES_SUCCESS";
export const FETCH_RESOURCES_FAILURE = "FETCH_RESOURCES_FAILURE";


//AGENT TYPES
//Auth 
export const AGENT_LOGIN_REQUEST ="AGENT_LOGIN_REQUEST";
export const AGENT_LOGIN_SUCCESS ="AGENT_LOGIN_SUCCESS";
export const AGENT_LOGIN_FAILURE ="AGENT_LOGIN_FAILURE";
export const AGENT_LOGOUT ="AGENT_LOGOUT";